// extracted by mini-css-extract-plugin
export default {"footer_container":"footer_footer_container__AmlSl","logo_container":"footer_logo_container__KVNQl"};